import React,{Component} from 'react';
import './shipping.css';
import Footer from '../Footer/Footer';
import Header from '../PrivacyPolicy/HeaderPrivacyTerms';

class ShippingPolicy extends Component{
    render(){
        return(
        <div id="shipping-policy-root">
            <div className="container">
                <Header />
            </div>
            <div className="shipping-policy-wrapper">
                <div className="shipping-policy-content">
                    <h3 style={{paddingTop:'70px'}}>Shipping Policy</h3>
                    <p>MobileOffize is a SaaS platform delivering solutions to customers on their smartphones and computers over the internet. No shipping is involved in the delivery of the product.</p>
                    <h3 style={{paddingTop:'20px'}}>Refund and Cancellation</h3>
                    <p>MobileOffize is a SaaS platform used on smartphones and computers to enable our customers to perform their business activities based on the processes enabled. Fees are paid in advance based on expected users and usage as negotiated with the customer. It automatically renews periodically (Yearly/Quarterly) unless the customer terminates by giving a written termination notice sixty (60) days in advance.</p>
                    <p style={{paddingBottom:'60px'}}>The Customer shall not be entitled to any refund for License or any one-time fees for the unexpired period remainder of the License in any circumstances.</p>
                </div>
            </div>
            <Footer />
        </div>
        )
    }
}
export default ShippingPolicy;


// WEBPACK FOOTER //
// ./src/components/ShippingPolicy/index.js